import { createAsyncThunk } from "@reduxjs/toolkit";
import { GET_DASHBOARDS } from "src/api/apiEndpoints";
import apiServices from "src/api/apiService";
import { ItemType } from "src/components/widgets/WidgetTypes";
import { API_KEY } from 'src/constants';




export const fetchGridStackLists = createAsyncThunk(
    'dashboard/fetchGridStackLists',
    async (_, {getState, rejectWithValue}) => {

      const currentState = getState();

      try{
        const data = await apiServices.dashboard.getUserDashboards(currentState.auth.userData.username);
        return data;
      }
      catch(error){
        return rejectWithValue(error.message);
      }
      
      
    }
  );
  export const fetchHomePage = createAsyncThunk(
    'dashboard/fetchHomePage',
    async (_, { rejectWithValue }) => {
      try {
        const data = await apiServices.dashboard.getHomePage();
        data.id = "homepagepublic";
        return data;
      } catch (error) {
        return rejectWithValue(error.message);
      }
    });

    export const editDashboardSave = createAsyncThunk('dashboard/editDashboardSave', async ( {dashboardId} , {getState, rejectWithValue}) => {
      let currentState = getState();
      let dashboardData = currentState.dashboard.gridStackList.find(
        (dashboard) => dashboard.id === dashboardId
      )?.dashboardData
      try {
          const userData = await apiServices.dashboard.editDashboard(currentState.auth.user.idToken, dashboardId, dashboardData);
          return userData;
        } catch (error) {
          return rejectWithValue(error.message);
        }
  });

  export const fetchDataVisData = createAsyncThunk('dashboard/fetchDataVisData', async ( _ , {getState, rejectWithValue}) => {
    let currentState = getState();

    try {
        const dataVisData = await apiServices.naruhone.getWanikaniData();
        return dataVisData;
      } catch (error) {
        return rejectWithValue(error.message);
      }
});

export const fetchNaruhoneData = createAsyncThunk('dashboard/fetchNaruhoneData', async ( _ , {getState, rejectWithValue}) => {
    let currentState = getState();
    try {
        const naruhoneData = await apiServices.naruhone.getNaruhoneData();
        return naruhoneData;
      } catch (error) {
        return rejectWithValue(error.message);
      }
});

export const getPublicMessages = createAsyncThunk('dashboard/getPublicMessages', async ( _ , {getState, rejectWithValue}) => {
    try {
        const naruhoneMessages = await apiServices.dashboard.getPublicMessages();
        
        return naruhoneMessages.publicMessages;
      } catch (error) {
        return rejectWithValue(error.message);
      }
});


